<template>
  <div>
    <div id="clear-queue-background"></div>
    <div id="clear-queue-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              You are disabling this channel. Do you want to clear the sync queue
              or keep it?
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.stop.prevent="handleCancel()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click.stop.prevent="handleKeep()"
            >
              Keep
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click.stop.prevent="handleClear()"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "clear-sync-queue-modal",
  methods: {
    handleCancel: function () {
      this.$emit("close-clear-modal");
    },
    handleKeep: function () {
      this.$emit("keep-sync-queue");
    },
    handleClear: function () {
      this.$emit("clear-sync-queue");
    },
  },
};
</script>

<style scoped lang="css">
  #clear-queue-modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }

  #clear-queue-background {
    position: fixed;
    z-index: 998;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.1);
    width: 100%;
    height: 100%;
  }
</style>